import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
    FETCH_NOTIFICATIONS_INIT_ACTION,
    FETCH_NOTIFICATIONS_SUCCESS_ACTION,
    FETCH_NOTIFICATIONS_ERROR_ACTION,
    FETCH_UNREADNOTIFICATIONS_INIT_ACTION,
    FETCH_UNREADNOTIFICATIONS_SUCCESS_ACTION,
    FETCH_UNREADNOTIFICATIONS_ERROR_ACTION,
    UPDATE_NOTIFICATIONS_INIT_ACTION,
    UPDATE_NOTIFICATIONS_SUCCESS_ACTION,
    UPDATE_NOTIFICATIONS_ERROR_ACTION,
    FETCH_SHOWNNOTIFICATIONS_INIT_ACTION,
    FETCH_SHOWNNOTIFICATIONS_SUCCESS_ACTION,
    FETCH_SHOWNNOTIFICATIONS_ERROR_ACTION
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";

let history = createBrowserHistory();

function* fetchnotifications(value) {
    const token = localStorage.getItem("token");
    const distID = JSON.parse(localStorage.getItem("userDetails")).id;

    let pageno = ((!value.value) ? 1: (value.value.page === undefined ? 1 : value.value.page));
    
    try {
      const res = yield fetch(
        `${appConfig.ip}/notfctn?userId=${distID}&limit=10&page=${pageno}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!res) {
        throw res;
      } else {
        const resJSON = yield res.json();
        yield put({
          type: FETCH_NOTIFICATIONS_SUCCESS_ACTION,
          payload: resJSON
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: FETCH_NOTIFICATIONS_ERROR_ACTION, error: err });
      } else {
      }
    }
  }

  function* unreadnotifications(value) {
    const token = localStorage.getItem("token");
    const distID = JSON.parse(localStorage.getItem("userDetails")).id;

    let pageno = ((!value.value) ? 1: (value.value.page === undefined ? 1 : value.value.page));
    
    try {
      const res = yield fetch(
        `${appConfig.ip}/notfctn?userId=${distID}&shown=false`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!res) {
        throw res;
      } else {
        const resJSON = yield res.json();
        yield put({
          type: FETCH_UNREADNOTIFICATIONS_SUCCESS_ACTION,
          payload: resJSON
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: FETCH_UNREADNOTIFICATIONS_ERROR_ACTION, error: err });
      } else {
      }
    }
  }

  function* updateNotification(value) {
    const token = localStorage.getItem("token");
    const distributorProfId = localStorage.getItem("distributorId");
  
    const data = {
      read:true,
    }
     try {
      const res = yield fetch(
        `${appConfig.ip}/notfctn/${value.value.id}`,
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(data)
        }
      );
  
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch {}
        throw Object.assign(res, errJSON);
      } else {
        const resJSON = yield res.json();
  
        yield put({
          type: UPDATE_NOTIFICATIONS_SUCCESS_ACTION,
          payload: resJSON
        });
        yield put({
          type: FETCH_NOTIFICATIONS_INIT_ACTION
        });
        yield put({
          type: FETCH_UNREADNOTIFICATIONS_INIT_ACTION
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({
          type: UPDATE_NOTIFICATIONS_ERROR_ACTION,
          error: err
        });
      } else {
      }
    }
   }

   function* shownNotifications(value) {
    const token = localStorage.getItem("token");
    const distributorProfId = localStorage.getItem("distributorId");
  
    const data = {
      shown:true,
    }
     try {
      const res = yield fetch(
        `${appConfig.ip}/notfctn/updateShown/${distributorProfId}`,
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(data)
        }
      );
  
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch {}
        throw Object.assign(res, errJSON);
      } else {
        const resJSON = yield res.json();
  
        yield put({
          type: FETCH_SHOWNNOTIFICATIONS_SUCCESS_ACTION,
          payload: resJSON
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({
          type: FETCH_SHOWNNOTIFICATIONS_ERROR_ACTION,
          error: err
        });
      } else {
      }
    }
   }

export function* NotificationsActionWatcher() {
    yield takeEvery(FETCH_NOTIFICATIONS_INIT_ACTION,fetchnotifications);
    yield takeEvery(UPDATE_NOTIFICATIONS_INIT_ACTION,updateNotification);
    yield takeEvery(FETCH_UNREADNOTIFICATIONS_INIT_ACTION,unreadnotifications);
    yield takeEvery(FETCH_SHOWNNOTIFICATIONS_INIT_ACTION,shownNotifications);
}